export const FETCH_BOOKINGS_LIST_REQUEST = 'FETCH_BOOKINGS_LIST_REQUEST';
export const FETCH_BOOKINGS_LIST_SUCCESS = 'FETCH_BOOKINGS_LIST_SUCCESS';
export const FETCH_BOOKINGS_LIST_FAILURE = 'FETCH_BOOKINGS_LIST_FAILURE';
